import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
} from '@angular/core';
import { Router } from '@angular/router';
import { RRHeaderModel } from '../../models/header-config.model';

@Component({
  selector: 'rr-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  isCollapsed = true;

  @Input() model: RRHeaderModel;
  @Input() isAuthenticated: boolean;
  @Output() login: EventEmitter<void> = new EventEmitter();
  @Output() logout: EventEmitter<void> = new EventEmitter();
  @Output() goToDocumentation: EventEmitter<void> = new EventEmitter();
  @Output() resetStorage: EventEmitter<string> = new EventEmitter();

  constructor(private renderer: Renderer2, private router: Router) {}

  ngOnInit() {
    if (typeof window !== undefined) {
      window.addEventListener('scroll', () => this.checkScroll());
    }

    if (this.isSafari()) {
      document.body.className += ' safari-browser';
    } else {
      document.body.className += ' no-safari-browser';
    }
  }

  goToHome(event): void {
    event.preventDefault();
    this.router.navigate([this.model.homeLink]);
  }
  onOpenDocumentation(): void {
    this.goToDocumentation.emit();
  }

  onLogin(): void {
    this.login.emit();
  }

  onLogout(): void {
    this.logout.emit();
  }

  onResetStorageClick(settings: string): void {
    this.resetStorage.emit(settings);
  }

  showProfile(): boolean {
    return (
      this.isAuthenticated &&
      this.model &&
      this.model.profile &&
      !this.model.profile.hide
    );
  }

  showDarkMode(): boolean {
    return this.model && !this.model.hideDarkMode;
  }

  showResetOptions(): boolean {
    return (
      this.isAuthenticated &&
      this.model &&
      !this.model.disabledReset &&
      !!this.resetStorage
    );
  }

  checkScroll(): void {
    if (typeof window !== undefined) {
      if (window.pageYOffset > 56) {
        this.renderer.addClass(document.body, 'scrolled');
      } else {
        this.renderer.removeClass(document.body, 'scrolled');
      }
    }
  }

  switchDarkmode(): void {
    if (document.body.classList.contains('darkmode')) {
      document.body.classList.remove('darkmode');
    } else {
      document.body.classList.add('darkmode');
    }
  }

  isSafari(): boolean {
    const ua = window.navigator.userAgent;
    const iOS = !!ua.match(/iP(ad|od|hone)/i);
    const hasSafariInUa = !!ua.match(/Safari/i);
    const noOtherBrowsersInUa = !ua.match(
      /Chrome|CriOS|OPiOS|mercury|FxiOS|Firefox/i,
    );
    let result = false;
    if (iOS) {
      //detecting Safari in IOS mobile browsers
      const webkit = !!ua.match(/WebKit/i);
      result = webkit && hasSafariInUa && noOtherBrowsersInUa;
    } else if (window['safari'] !== undefined) {
      //detecting Safari in Desktop Browsers
      result = true;
    } else {
      // detecting Safari in other platforms
      result = hasSafariInUa && noOtherBrowsersInUa;
    }
    return result;
  }
}
